import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import katex from 'katex';
import { DataDisplayBlock } from '../../../model';

@Component({
  selector: 'dojo-data-display-block-renderer',
  standalone: true,
  template: ` <div class="data-display-content" [innerHTML]="renderedHtml()"></div> `,
  styles: `
    :host {
      @apply block my-4;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 12px 16px;
      background: #fafafa;
    }

    .data-display-content {
      font-size: 0.875rem;
      line-height: 2;
      text-align: center;

      ::ng-deep .data-value {
        display: inline;
        white-space: nowrap;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataDisplayBlockRendererComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly block = input.required<DataDisplayBlock>();

  readonly renderedHtml = computed<SafeHtml>(() => {
    const raw = this.block().data;
    if (!raw || !raw.trim()) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const values = raw
      .split(',')
      .map((v) => v.trim())
      .filter((v) => v.length > 0);

    try {
      const parts = values.map((v, i) => {
        const rendered = katex.renderToString(v, { throwOnError: false, displayMode: false, output: 'html' });
        const separator = i < values.length - 1 ? ',\u2002' : '';
        return `<span class="data-value">${rendered}${separator}</span>`;
      });
      return this.sanitizer.bypassSecurityTrustHtml(parts.join(''));
    } catch {
      return this.sanitizer.bypassSecurityTrustHtml(raw);
    }
  });
}
